import React from 'react';
import './MealArtwork.css';

function MealArtwork({variant,image}) {
  return (
    <div className={`meal-artwork meal-${variant}`} aria-hidden="true">
      <img
        className="meal-food-image"
        src={image}
        alt=""
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

export default MealArtwork;